import { Link } from 'react-router';
import { useI18n } from '../i18n';
import { Petal, Plate, Splat } from '../ui/chrome';

/** Stripe sends buyers here; the webhook does the granting, so this page only thanks them. */
export function SuccessPage() {
  const { t } = useI18n();
  return (
    <section className="small-page">
      <SmallPageDecor />
      <div className="wrap">
        <div className="card done">
          <Plate as="h1" large petal>
            {t('success.title')}
          </Plate>
          <img src="/art/pack_6.webp" alt="" width={150} height={130} style={{ objectFit: 'contain' }} />
          <p>{t('success.body')}</p>
          <div className="actions">
            <Link className="btn btn-pink" to="/account">
              {t('success.toAccount')}
            </Link>
            <Link className="btn btn-ink" to="/shop">
              {t('success.toShop')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

/** Manga pages, ink and petals around a single card. */
export function SmallPageDecor() {
  return (
    <>
      <div className="small-bg wide-only" aria-hidden />
      <Splat n={1} style={{ right: 160, top: 380, width: 180, zIndex: 1, wide: true }} />
      <Petal n={1} style={{ left: '24%', top: 30, width: 50, zIndex: 1 }} />
      <Petal n={2} style={{ right: '22%', bottom: 30, width: 40, zIndex: 1 }} />
    </>
  );
}
